import { sessionContext, useSessionContextValue } from './context';

export interface SessionProviderProps {
  children: ReactNode;
}

export function SessionProvider({ children }: SessionProviderProps) {
  const value = useSessionContextValue();
  return <sessionContext.Provider value={value}>{children}</sessionContext.Provider>;
}
